import React from 'react'
import Header from '../components/Header';
import classes from "./InfoPage.module.css";

const InfoPage = () => {
  return (
    <>
            <Header />
              <div className={classes.container}>
                <div className={classes.description}>
                    <h2 className={classes.title}>Subscription In Process</h2>
                    <ul className={classes.list}>
                        <li className={classes.text}>
                            Your subscription request is submitted!
                        </li>
                    </ul>

                </div>
            </div>
    </>
  )
}

export default InfoPage